<template lang="pug">
.bet-slip
  .bet-slip-wrapper
    .stake-info-wrapper
      .bet-type
        .head-wrapper
          ThemeImage.icon(:src="'/images/light/game-type/4d.svg'")
          | {{ $t("ui.w4d") }}
        template(v-if="!status")
          .bet-status.won(v-if="parseFloat(match.winlose) > 0")
            span {{ $t("ui.win") }}
          .bet-status.draw(v-else-if="parseFloat(match.winlose) == 0")
            span {{ $t("ui.draw") }}
          .bet-status.lose(v-else-if="parseFloat(match.winlose) < 0")
            span {{ $t("ui.lose") }}
        template(v-else)
          .bet-status(:class="match.bet_status.toLowerCase()")
            span {{ $t("ui." + match.bet_status.toLowerCase()) }}
      .stake-info
        .betslip-match
          .team-involved
            span.text-danger {{ match.comp_name }} - {{ match.num_type }}  
            span.d-block {{ $t("m.D_" + match.bet_type) }}
            //- span.d-block.font-weight-bold {{ match.number }}
            //- span.text-danger {{ match.comp_name }} - {{ match.num_type }}  
            //- span.text-info @ {{ $dayjs(match.match_date).format("MM/DD/YYYY") }}
        .selector-odd
          span.text
            //- span.market-type {{ match.comp_name }} - {{ match.num_type }}
            span.team-name {{ match.number }}
          .bet-type-odds
            .odds
              span {{ $dayjs(match.match_date).format("MM/DD/YYYY") }}

      .payout-wrapper
        .left
          | {{ $t("ui.stake") }}: 
          span.amount {{ $numeral(match.bet_member).format("0,0.[00]") }}
        .right(v-if="match.winlose")
          span.amount {{ parseFloat(match.winlose) < 0 ? $t("ui.lose") : $t("ui.win") }}:
          span.amount(:class="match.winlose != 0 ? match.winlose > 0 ? 'win-amount' : 'lose-amount' : ''") {{ $numeral(match.winlose).format("0,0.00") }}

      .collapse(:id="'statement-child-' + this.uniqueID" :data-bsparent="'#statement-' + index")
        .bet-details
          .bet-details-row
            .left {{ $t("ui.ref_no") }}: {{ match.ticket_id }} / {{ match.bet_id }}
            .right {{ $t("ui.event") }}: {{ $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
          .bet-details-row
            .small(v-if="parseFloat(match.big) > 0")
              span {{ match.num_type == "4D" ? $t("m.D_BIG") : "AE" }}
              span  x {{ $numeral(match.big).format("0,0.00") }}
            .small(v-if="parseFloat(match.small) > 0")
              span {{ $t("m.D_SMALL") }}
              span  x {{ $numeral(match.small).format("0,0.00") }}
            .small(v-if="parseFloat(match.sa) > 0")
              span {{ match.num_type == "4D" ? "SA" : "A" }}
              span  x {{ $numeral(match.sa).format("0,0.00") }}
            .small(v-if="parseFloat(match.sb) > 0")
              span B
              span  x {{ $numeral(match.sb).format("0,0.00") }}
            .small(v-if="parseFloat(match.sc) > 0")
              span C
              span  x {{ $numeral(match.sc).format("0,0.00") }}
            .small(v-if="parseFloat(match.sd) > 0")
              span D
              span  x {{ $numeral(match.sd).format("0,0.00") }}
            .small(v-if="parseFloat(match.se) > 0")
              span E
              span  x {{ $numeral(match.se).format("0,0.00") }}
            .small(v-if="parseFloat(match.aa) > 0")
              span AA
              span  x {{ $numeral(match.aa).format("0,0.00") }}
            .small(v-if="parseFloat(match.abc) > 0")
              span ABC
              span  x {{ $numeral(match.abc).format("0,0.00") }}
      .btn-more-detail(:id="'statement-child-btn-' + this.uniqueID" data-bs-toggle='collapse' :data-bs-target="'#statement-child-' + this.uniqueID" :aria-expanded="detailsExpanded" :aria-controls="'statement-child-' + this.uniqueID") {{ detailButtonText }}

</template>

<script>  
import betSlipDetailToggle from "@/mixins/betSlipDetailToggle";

export default {
  mixins: [betSlipDetailToggle],
  props: {
    index: {
      type: Number,
      default: 0
    },
    match: {
      type: [Object, Array]
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    uniqueID() {
      if(this.match) {
        return this.match.result_id || this.match.bet_id
      }
    }
  }
}
</script>